import { action, get } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import modelUtils from 'donor-elf-web/lib/model-utils';
import RSVP from 'rsvp';

export default Route.extend({
  cachedDataset: service(),
  fundsService: service(),
  storeCache: service(),
  store: service(),
  abilities: service(),

  beforeModel() {
    return this.fundsService.confirmValidFundToken();
  },

  model() {
    let user = this.modelFor('admin.users.show');
    let userId = get(user, 'id');
    let storeCache = this.storeCache;
    let logins = RSVP.resolve(null);
    let emails = RSVP.resolve(null);
    let fundGroupInfo = RSVP.resolve([]);
    if (this.abilities.hasAbility('view_logins_and_emails')) {
      logins = this.store.query('admin/login', { filter: { user_id: userId } });
      emails = this.store.query('admin/email', { filter: { user_id: userId } });
    }
    if (this.abilities.hasAbility('view_fund_groups')) {
      fundGroupInfo = this.store
        .query('admin/fund-group-user', { filter: { user_id: userId } })
        .then((fundGroupUsers) => {
          if (get(fundGroupUsers, 'length') > 0) {
            return this.storeCache
              .indexSingleBy('admin/fund-group', 'id')
              .then((fundGroupsById) => {
                return fundGroupUsers.map((fgUser) => {
                  return {
                    fundGroupUser: fgUser,
                    fundGroup: fundGroupsById[get(fgUser, 'fundGroupId')],
                  };
                });
              });
          } else {
            return [];
          }
        });
    }
    let promise = RSVP.hash({
      funds: this.store.query('admin/fund', { filter: { user_id: userId } }),
      userFunds: this.store.query('admin/user-fund', {
        filter: { user_id: userId },
      }),
      logins: logins,
      emails: emails,
      fundGroupInfo: fundGroupInfo,
    });
    return promise.then((data) => {
      let userFunds = modelUtils.filterPersisted(data.userFunds?.slice() || []);
      let fundsById = {};
      data.funds.forEach((fund) => {
        fundsById[fund.id] = fund;
      });

      let hasUserFundForFundId = {};
      let fundPermissions = [];
      userFunds.forEach((userFund) => {
        hasUserFundForFundId[get(userFund, 'fundId')] = true;
        fundPermissions.push({
          userFund: userFund,
          fund: fundsById[get(userFund, 'fundId')],
        });
      }),
        data.fundGroupInfo.forEach((item) => {
          let fundGroup = get(item, 'fundGroup');
          let fundGroupUser = get(item, 'fundGroupUser');
          get(fundGroup, 'fundIds').forEach((fundId) => {
            if (!hasUserFundForFundId[fundId]) {
              fundPermissions.push({
                fundGroup: fundGroup,
                fundGroupUser: fundGroupUser,
                fund: fundsById[fundId],
              });
            }
          });
        });

      return {
        user: user,
        fundAndUserFunds: userFunds.map((userFund) => {
          return {
            userFund: userFund,
            fund: fundsById[get(userFund, 'fundId')],
          };
        }),
        fundPermissions: fundPermissions,
        logins: data.logins,
        emails: data.emails,
        fundGroupInfo: data.fundGroupInfo,
      };
    });
  },

  remove: action(function (model) {
    if (get(this.currentModel.fundAndUserFunds, 'length') === 1) {
      alert(
        "You can't remove this fund since it's the only fund the user has permission to see.",
      );
      return;
    }
    if (confirm('Are you sure you want to remove this fund permission?')) {
      get(model, 'userFund')
        .destroyRecord()
        .then(() => {
          this.storeCache.breakFindAllCache('admin/user-fund');
          this.refresh();
        });
    }
  }),
});
